import React, { useState } from 'react'
import { Typography, Stack, Fade } from '@mui/material'
import MetricsCardsGrid from './MetricsCardsGrid'
import { CardData, CardViewMode } from './types'
import { Toggle } from '../Toggle/Toggle'

interface MetricsCardsProps {
    cards: CardData[]
}

const MetricsCards = ({ cards }: MetricsCardsProps) => {
    const [viewMode, setViewMode] = useState<CardViewMode>('graphs')

    const toggleViewMode = () => {
        setViewMode(viewMode === 'graphs' ? 'list' : 'graphs')
    }

    if (!cards.length) return null

    return (
        <Stack direction="column" gap={2} mt={3}>
            <Stack direction="row" alignItems="center" justifyContent="flex-end" gap={0.75}>
                <Typography
                    variant="16x400"
                    onClick={() => setViewMode('list')}
                    sx={{
                        cursor: 'pointer',
                        userSelect: 'none',
                        '&:hover': { opacity: 0.8 },
                    }}
                >
                    List
                </Typography>
                <Toggle checked={viewMode === 'graphs'} onChange={toggleViewMode} />
                <Typography
                    variant="16x400"
                    onClick={() => setViewMode('graphs')}
                    sx={{
                        cursor: 'pointer',
                        userSelect: 'none',
                        '&:hover': { opacity: 0.8 },
                    }}
                >
                    Graphs
                </Typography>
            </Stack>
            <MetricsCardsGrid cards={cards} viewMode={viewMode} />
        </Stack>
    )
}

export default MetricsCards
